<template>
    <Card class="ly-g2-chart">
        <p slot="title">
            {{attrs.title}}
        </p>
        <a href="javascript:void(0);" slot="extra" v-if="attrs.isSearch && attrs.isFoldSearch" @click="isSearchShow = !isSearchShow">
            <template v-if="!isSearchShow">
                <Icon type="ios-funnel" />
                筛选
            </template>
            <template v-else>
                <Icon type="ios-arrow-up" />
                收起筛选
            </template>
        </a>
        <ly-g2-search :attrs="attrs" v-if="(attrs.isSearch && isSearchShow) || (attrs.isSearch && !attrs.isFoldSearch)" @search="queryData"></ly-g2-search>
        <Row>
            <Col :span="attrs.isRank ? 18 : 24">
                <!-- 统计 start -->
                <ly-g2-statistic v-if="attrs.isStatistic" :list="chartData.statistic"></ly-g2-statistic>
                <!-- 统计  end  -->
                <ly-chart-render :attrs="attrs" :chart-data="chartData.chart" :key=""></ly-chart-render>
            </Col>
            <Col span="6" v-if="attrs.isRank">
                <!-- 排名 start -->
                <ly-g2-rank :title="attrs.rankTitle" :list="chartData.rank"></ly-g2-rank>
                <!-- 排名  end  -->
            </Col>
        </Row>
        <Spin size="large" fix v-if="spinShow"></Spin>
    </Card>
</template>
<script>
    import { Chart } from '@antv/g2'
    import LyG2Search from './search'
    import LyG2Rank from './rank'
    import LyG2Statistic from './statistic'
    import LyChartRender from './chartRender'
    /**
     * 路易报表用到的图形化，尽力抽象，使其能够重用
     * @time 2020-09-07
     * @author zjs
     */
    export default {
        name: 'LyG2Chart',
        props: {
            attrs: {
                type: Object,
                default: _ => new Object()
            } // 组件的配置
        },
        data () {
            return {
                spinShow: false,
                isSearchShow: false, // 控制搜索的现实
                isFirst: true,
                renderKey: 1,
                chartData: {
                    chart: [],
                    rank: [],
                    statistic: []
                }
            }
        },
        components: {
            LyG2Search,
            LyG2Rank,
            LyG2Statistic,
            LyChartRender
        },
        watch: {
            '$route' () {
                if (!this.isFirst) {
                    this.$nextTick(() => {
                        this.queryData({})
                    })
                }
            }
        },
        created () {
            this.renderKey = parseInt(Math.random() * 1000)
            this.isFirst = false
            this.queryData({})
            // 监听数据查询的事件
            this.$eventHub.$on(this.$events.SEARCH_DATA, this.handleSearchData)
        },
        methods: {
            queryData (params) {
                this.spinShow = true
                this.$api.query(this.attrs.api, params).then((rs) => {
                    this.spinShow = false
                    this.chartData = rs
                }).catch((err) => {
                    this.spinShow = false
                })
            },
            forceRerender () {
                this.renderKey = parseInt(Math.random() * 1000)
            },
            handleSearchData (params) {
                console.log("params", params)
                this.queryData(params)
            } 
        },
    destroyed () {
        // 销毁事件的监听
        this.$eventHub.$off(this.$events.SEARCH_DATA, this.handleSearchData)
    }
    }
</script>
<style>
    .ly-g2-chart {
        min-height: 300px;
    }
</style>



// WEBPACK FOOTER //
// ../projectCore/src/components/g2-chart/src/index.vue